import create from 'zustand';

import markerData from '../data/markers';

const useMarker = create((set, get) => ({
    visible: false,
    id: null,
    setVisible: (visible) => set({ visible: visible }),
    setId: (id) => set({ id: id }),
    getCurrent: () => {
        return markerData.filter((marker) => marker.barcodeValue === get().id)?.[0] || null;
    },
}));

export default useMarker;
